import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { MarketplaceOfferingDetailsClient } from "../Types";
export const clientMarketplaceOfferingUrl = (offeringId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/alt-asset/v3/client/offering/${offeringId}`
    : `https://middleware.uat.farther.com/alt-asset/v3/client/offering/${offeringId}`;
export default async function getClientMarketplaceOfferingV2(offeringId, config) {
    const { data } = await axios.get(clientMarketplaceOfferingUrl(offeringId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = MarketplaceOfferingDetailsClient.shape.v2.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getClientMarketplaceOfferingV2] returned unexpected data.";
        errorLog(getClientMarketplaceOfferingV2.name, JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getClientMarketplaceOfferingV2.js.map